export const getTickDimension = (rounded, size) => {
  let width = 10;
  const circularWidths = {
    md: 10,
    sm: 6.25
  };
  const squareWidths = {
    md: 12.5,
    sm: 10
  };
  if (rounded) {
    width = circularWidths[size];
  } else {
    width = squareWidths[size];
  }
  const height = width * 0.667;
  return {
    width,
    height
  };
};
export const getIndeterminateBarWidth = (rounded, size) => {
  const circularWidths = {
    md: 10,
    sm: 6.25
  };
  const squareWidths = {
    md: 12.5,
    sm: 10
  };
  if (rounded) {
    return circularWidths[size];
  }
  return squareWidths[size];
};